import React from "react";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
import StarIcon from "@mui/icons-material/Star";
import PsychologyIcon from "@mui/icons-material/Psychology";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ShieldIcon from "@mui/icons-material/Shield";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";

const GameRules = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        How to Play: Raja Mantri Chor Sipahi (RMCS)
      </Typography>

      <Typography variant="body1" paragraph>
        RMCS is a web-based multiplayer game based on the classic Indian game
        "Raja, Mantri, Chor, Sipahi". Each round is filled with mystery,
        bluffing, and strategy. Play with friends, guess roles, and earn points!
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <TheaterComedyIcon sx={{ fontSize: 22 }} /> Roles in the Game
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon sx={{ minWidth: 36 }}><StarIcon sx={{ color: "#FFD700" }} /></ListItemIcon>
          <ListItemText
            primary="Raja (King)"
            secondary="Earns the most points but has no active role."
          />
        </ListItem>
        <ListItem>
          <ListItemIcon sx={{ minWidth: 36 }}><PsychologyIcon color="info" /></ListItemIcon>
          <ListItemText
            primary="Mantri (Minister)"
            secondary="Must identify the Chor (Thief)."
          />
        </ListItem>
        <ListItem>
          <ListItemIcon sx={{ minWidth: 36 }}><VisibilityOffIcon color="error" /></ListItemIcon>
          <ListItemText
            primary="Chor (Thief)"
            secondary="Tries to stay hidden and not get caught."
          />
        </ListItem>
        <ListItem>
          <ListItemIcon sx={{ minWidth: 36 }}><ShieldIcon color="success" /></ListItemIcon>
          <ListItemText
            primary="Sipahi (Soldier)"
            secondary="Does not participate in the guessing."
          />
        </ListItem>
      </List>

      <Typography variant="h6" gutterBottom sx={{ mt: 3, display: "flex", alignItems: "center", gap: 1 }}>
        <GpsFixedIcon sx={{ fontSize: 22 }} /> Objective
      </Typography>
      <Typography variant="body1" paragraph>
        The Mantri's job is to correctly guess who among the remaining players
        is the Chor. Everyone else tries to bluff or stay innocent to avoid
        being identified as the Chor.
      </Typography>

      <Typography variant="h6" gutterBottom sx={{ mt: 3, display: "flex", alignItems: "center", gap: 1 }}>
        <EmojiEventsIcon sx={{ fontSize: 22 }} /> Points System
      </Typography>

      <Typography variant="body1" paragraph>
        Points are distributed based on how well the Mantri performs. If the
        Mantri guesses the Chor correctly, they and the Sipahi earn points. If
        the guess is wrong, the Chor takes the Mantri's points instead. Raja
        always gets points.
      </Typography>

      <TableContainer component={Paper} sx={{ mb: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Role</strong>
              </TableCell>
              <TableCell>
                <strong>Condition</strong>
              </TableCell>
              <TableCell>
                <strong>Points</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Raja</TableCell>
              <TableCell>Always</TableCell>
              <TableCell>+10</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Mantri</TableCell>
              <TableCell>Guesses Chor correctly</TableCell>
              <TableCell>+7</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Mantri</TableCell>
              <TableCell>Guesses Chor incorrectly</TableCell>
              <TableCell>0</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Chor</TableCell>
              <TableCell>Identified correctly by Mantri</TableCell>
              <TableCell>0</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Chor</TableCell>
              <TableCell>Escapes (Mantri guesses incorrectly)</TableCell>
              <TableCell>+7</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Sipahi</TableCell>
              <TableCell>Always</TableCell>
              <TableCell>+5</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h6" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <SportsEsportsIcon sx={{ fontSize: 22 }} /> How to Play
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="1. Roles are randomly and secretly assigned to each player." />
        </ListItem>
        <ListItem>
          <ListItemText primary="2. Only the Mantri is asked to guess who the Chor is." />
        </ListItem>
        <ListItem>
          <ListItemText primary="3. After the guess, points are awarded based on the outcome." />
        </ListItem>
        <ListItem>
          <ListItemText primary="4. Roles are reshuffled for the next round, and the game continues." />
        </ListItem>
        <ListItem>
          <ListItemText primary="5. The player with the highest total points at the end wins!" />
        </ListItem>
      </List>

      <Box sx={{ mt: 2 }}>
        <Typography variant="body2" color="text.secondary" fontStyle="italic">
          Bluff smartly. Guess wisely. Laugh endlessly!
        </Typography>
      </Box>
    </Container>
  );
};

export default GameRules;
